import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { CustomerArea } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class CustomerAreaService {

    static Areas: Array<CustomerArea> = [];

    constructor(
        private apiService: ApiService
    ) {}
    
    async init(){   
        CustomerAreaService.Areas = await this.loadCustomersAreas(); 
    }
    
    reset(){        
        CustomerAreaService.Areas = [];
    }

    async loadCustomersAreas(): Promise<CustomerArea[]> {
        let areas: Array<CustomerArea> = [];
        let response = await this.apiService.get('field-team/my-areas');
        if(response?.data?.elements){
            areas = response.data.elements;
        }
        return areas;
    }
}
